<template>
    <div class="f fw fj-sb">
        <button class="br-m"
            type="button"
            :style="{'background-color': el}"
            @click="select(el)"
            v-for="(el, index) in list"
            :key="index">
        </button>
    </div>
</template>

<script>
import { guuid } from '@aretheyhappy/utils';

export default {
    name: 'mead-form-color-list',
    props: {
        /**
         * Data injected by the popover host; expects `{pubkey, list}` where `pubkey` identifies the
         * Flash channel to publish the selected color to and `list` is the array of hex colors to render.
         */
        popoverdata : {type: Object, default: () => ({})},
    },
    data () {
        return {
            uid: this.popoverdata.pubkey || guuid(),
            list: this.popoverdata.list || [],
        };
    },
    methods: {
        select: function (el) {
            MeadCommon.Flash.publish(`${this.uid}:colorpicked`, {selected: el});
            this.$emit('actClose');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../../../sass/_variables.scss';

$i_rowsize  : 5;
$i_width    : 2.5rem;
$i_height   : 3rem;
$i_margin   : .5rem;

div {
    width: calc(#{$i_rowsize} * #{$i_width} + ((#{$i_rowsize} - 1) * #{$i_margin}));
}

button {
    display: block;
    width: $i_width;
    height: $i_height;
    border: none;
    cursor: pointer;
    margin: 0 $i_margin $i_margin 0;
    box-shadow: 0 1px 0 1px var(--c-brand-light-bg);

    &:hover,
    &:focus,
    &:active {
        outline: none;
        box-shadow: 0 2px 2px 1px var(--c-panel-border);
        transform: scale3d(1.1, 1.1, 1.1);
    }

    //  Every 5th child should not have right margin
    &:nth-of-type(#{$i_rowsize}n) {
        margin-right: 0;
    }

    //  Last 5 children should not have bottom margin
    &:nth-last-child(-n + #{$i_rowsize}) {
        margin-bottom: 0;
    }
}
</style>
